import { HdWizardStepTrackerOptions, HdWizardStepTrackingStrategy } from './interface';

export const DEFAULT_TRACKER_OPTIONS: HdWizardStepTrackerOptions = {
  trackingStrategy: HdWizardStepTrackingStrategy.DISCARD_ON_DIRTY
};
